
import { useState } from "react"
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, LinearProgress, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { useQuery } from "react-query";
import useDebounce from "../../../lib/useDebounce";
import axiosClient from "../../../lib/axios";
import LoadingApiQuery from "../../LoadingApiQuery";
import { OnChangeValue, Value } from ".";
import { CulturaReceituario, PragaReceituario } from "../../../types/api/comercial/pesquisar-cultura-praga-receituario";
import DialogSelectPraga from "./DialogSelectPraga";

export default function DialogSelectCultura({
    open,
    handleClose,
    defValue,
    onSubmitValue,
    agrotoxico_id
}: DialogSelectCulturaProps) {

    const [keyword, setKeyword] = useState<string>("")
    const [selected, setSelected] = useState<Value>(defValue)
    const [openModal, setOpenModal] = useState<boolean>(false)

    //queries e mutations
    const debouncedKeyword = useDebounce(keyword)
    const { data, isFetching, isLoading } = useQuery({
        queryKey: ['/receituario-agronomico/pesquisar-cultura', debouncedKeyword, agrotoxico_id],
        queryFn: () => axiosClient.get("/receituario-agronomico/pesquisar-cultura", {
            params: {
                pesquisar: debouncedKeyword,
                agrotoxico_id
            }
        }),
        retry: false,
        keepPreviousData: true,
        cacheTime: 0
    });
    const dadosCultura: CulturaReceituario[] = data?.data || []
    //  

    //funções manipuladoras
    const handleSubmit = () => {
        if (selected) {
            onSubmitValue(selected)
            handleClose()
        }
    }

    const handleSelecionarPraga = (valorSelect: PragaReceituario) => {
        if (selected) {
            const param = {
                ...selected,
                ...valorSelect
            }
            onSubmitValue(param)
            handleClose()
        }
    }
    //  

    //valores importantes
    const bloquearConfirmar = !selected
    //

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="body"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle >
                    Selecionar cultura
                </DialogTitle>

                <DialogContent>
                    <Box py={2}>
                        <TextField
                            fullWidth
                            value={keyword}
                            label="Pesquisar"
                            onChange={({ target }) => setKeyword(target.value)}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }
                            }}
                        />

                        {isLoading && <LoadingApiQuery extraParams={{ height: 400, my: 1, alignItems: "center" }} />}

                        <Box mt={1}>{(isFetching && data) && <LinearProgress />}</Box>
                        {
                            (!isLoading && data) &&
                            <TableContainer
                                sx={{ height: 400, overflow: "auto", mb: 1 }}
                            >

                                <Table size="small" aria-label="a dense table" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell><b>Nome</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dadosCultura.map((row) => {
                                            const identificador = row.cultura_id.toString()
                                            const radioMarcado = selected?.cultura_id === row.cultura_id

                                            return (
                                                <TableRow
                                                    key={row.cultura_id}
                                                    sx={{
                                                        cursor: "pointer",
                                                        backgroundColor: radioMarcado ? "#edf7ed" : "unset",
                                                        '&:last-child td, &:last-child th': { border: 0 }
                                                    }}
                                                    onClick={() => {
                                                        setOpenModal(true)
                                                        setSelected(row)
                                                    }}
                                                >
                                                    <TableCell>
                                                        <Radio
                                                            name="radio-buttons"
                                                            checked={radioMarcado}
                                                            slotProps={{ input: { 'aria-label': identificador } }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography
                                                            variant="subtitle2"
                                                        >
                                                            {row.nome_cultura}
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={handleClose}
                    >
                        Cancelar
                    </Button>
                    <Button
                        autoFocus
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={bloquearConfirmar}
                    >
                        Selecionar
                    </Button>
                </DialogActions>
            </Dialog>

            {
                (openModal && selected) &&
                <DialogSelectPraga
                    {...{ agrotoxico_id }}
                    open={openModal}
                    cultura_id={selected.cultura_id}
                    handleClose={() => {
                        setOpenModal(false)
                        setSelected(null)
                    }}
                    handleSubmit={handleSelecionarPraga}
                />
            }
        </>
    )
}

interface DialogSelectCulturaProps {
    open: boolean,
    handleClose: () => void,
    defValue: Value,
    onSubmitValue: OnChangeValue,
    agrotoxico_id: number
}